<template>
	<div
		class="relatedReading"
		:style="{
			marginTop: data.marginTop + 'px',
			paddingTop: data.paddingTop + 'px',
			paddingLeft: data.paddingLeft + '%',
			paddingRight: data.paddingRight + '%',
		}"
	>
		<div v-if="data.content || data.data.length > 0">
			<div
				class="myfxBox"
				:style="{
					backgroundImage: 'url(' + (data.backgroundImage == '' ? 'https://kchi.obs.cn-north-4.myhuaweicloud.com/jdzy/chinaMedVideo/listDetail_26/myfx_box.jpg' : data.backgroundImage) + ')',
					padding: data.contPadding,
				}"
			>
				<div v-for="(item, index) in data.data" :key="index">
					<div
						class="ld_video_item"
						@click="videoPlay(index)"
						:style="{
							backgroundImage: 'url(' + item.listImage + ')',
						}"
					>
						<img
							src="https://kchi.obs.cn-north-4.myhuaweicloud.com/jdzy/chinaMedVideo/listDetail_26/guankan.gif"
							alt=""
							class="guankan"
							:style="{
								left: item.left + 'px',
								top: item.top + 'px',
							}"
						/>
					</div>
				</div>
			</div>
		</div>

		<div v-else>
			<div class="myfxBox">
				<div class="ld_video_item">
					<img src="https://kchi.obs.cn-north-4.myhuaweicloud.com/jdzy/chinaMedVideo/listDetail_26/guankan.gif" alt="" class="guankan" />
				</div>
			</div>
		</div>

		<div class="model-box" v-if="modelShow">
			<div class="modal">
				<video style="width: 100%; height: 80vh" controls :poster="videoJson.poster">
					<source :src="videoJson.src" type="video/mp4" />
					您的浏览器不支持 HTML5 video 标签。
				</video>
				<div class="modal-content">
					<img src="../../assets/img/gf-ver1/modal-close.png" class="modal-close" @click="modelShow = false" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'doctorsSharing',
	props: ['data'],
	data() {
		return {
			modelShow: false,
			videoJson: {},
		};
	},

	methods: {
		videoPlay(index) {
			this.modelShow = true;
			var list1 = this.data.data;
			this.videoJson.poster = list1[index].poster;
			this.videoJson.src = list1[index].src;
		},
	},
};
</script>

<style lang="scss" scoped>
.myfxBox {
	overflow: hidden;
	background-image: url('https://kchi.obs.cn-north-4.myhuaweicloud.com/jdzy/chinaMedVideo/listDetail_26/myfx_box.jpg');
	background-repeat: no-repeat;
	background-size: 100% 100%;
	padding: 75px 25px 15px;
	.ld_video_item {
		margin: 0 auto;
		width: 100%;
		height: 121px;
		overflow: hidden;
		background-image: url('https://kchi.obs.cn-north-4.myhuaweicloud.com/jdzy/chinaMedVideo/listDetail_26/ld_video_1.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		position: relative;
		img {
			width: 64px;
			height: 20px;
			position: absolute;
			right: 6%;
			top: 12px;
		}
	}
}

/* 弹窗 */
.model-box {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.7);
	z-index: 101;
}

.modal {
	width: 80%;
	height: 80vh;
	margin: 5vh auto 0;
}

.modal-close {
	display: block;
	width: 40px;
	margin: 28px auto;
}
</style>